function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "icon-close",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "close---material",
  fill: "#4A4A4A",
  points: "21.82 11.36 17.18 16 21.82 20.64 20.64 21.82 16 17.18 11.36 21.82 10.18 20.64 14.82 16 10.18 11.36 11.36 10.18 16 14.82 20.64 10.18"
}));

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default __webpack_public_path__ + "a4d2e04e48f4a281a5dcf48e3196e364.svg";
export { SvgIconClose as ReactComponent };